import { render, staticRenderFns } from "./ModalVideo.vue?vue&type=template&id=3ca8d801&scoped=true&"
import script from "./ModalVideo.vue?vue&type=script&lang=ts&"
export * from "./ModalVideo.vue?vue&type=script&lang=ts&"
import style0 from "./ModalVideo.vue?vue&type=style&index=0&id=3ca8d801&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca8d801",
  null
  
)

export default component.exports